import { atoms } from '@fiverr-private/theme';

export const containerPaddingXByMdBreakpoint = atoms({
    paddingX: {
        md: '8',
        default: '6',
    },
});
